define('modules/editor/services/video_content/index',['require','exports','module','common/models/appstate','../../models/editorstate','../../views/editors/video_amp','../../views/editors/video'],function(require, exports, module){
  "use strict";
  var AppState = require("common/models/appstate"),
      EditorState = require("../../models/editorstate");

  module.exports = {
    _getVideoEditorView: function () {
      if (EditorState.getAMPState()) {
        return require("../../views/editors/video_amp");
      }

      return require("../../views/editors/video");
    },

    editVideo: function(content, callback){
      var VideoEditorView = this._getVideoEditorView();

      AppState.setPropsPopUpOpen(true);
      var videoView = new VideoEditorView({
        content: content
      });

      videoView.once("modal:save", function(results) {
        callback(results);
        videoView.hide();
        AppState.setPropsPopUpOpen(false);
      });
    }
  };
});

